import { StyleSheet } from "react-native-unistyles";

import { ANIMATIONS } from "$src/core/constants/css";

const stylesheet = StyleSheet.create(
  ({ colors, spacing, border, shadows }) => ({
    overlay: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      padding: spacing(4),
      cursor: "auto",
    },
    backdrop: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
    modal: {
      width: "100%",
      maxWidth: spacing(105),
      backgroundColor: colors.backgroundFloat,
      borderRadius: border.radius.lg,
      borderWidth: border.widths.md,
      borderColor: colors.borderDefault,
      boxShadow: shadows.modal,
      _web: {
        animation: `${ANIMATIONS.FADE_SLIDE_IN} 0.2s ease-out`,
        maxHeight: "90svh",
      },
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      paddingVertical: spacing(1),
      paddingHorizontal: spacing(5),
      borderBottomWidth: border.widths.md,
      borderBottomColor: colors.borderDefault,
    },
    title: {
      flex: 1,
    },
    content: {
      padding: spacing(5),
    },
  }),
);

export default stylesheet;
